import { JsonProperty } from "../../../models/utilities/json-property";
import { ProductionRunStatus } from "../enums/production-run-status";
import { ScheduleMetric } from "./schedule-metric";

export class ProductionRunDto {

    public id : number = 0;
    
    public name : string = '';

    public shipmentId : number|undefined = undefined;

    public rank : string = '';
    
    @JsonProperty({ toType: 'datetime-specific' })
    public departureTimeLocal : Date|undefined = undefined;
        
    @JsonProperty({  toClass: ScheduleMetric, designType: 'array' })
    public jobs : ScheduleMetric[] = [];

}
